const ACTION_ITEMS = {
  NAVBAR: {
    SET_CURRENT_PAGE_TAB: 'SET_CURRENT_PAGE_TAB',
    SELF_DONE: {
      SET: 'NAVBAR_SELF_DONE_SET'
    },
    TECHNICAL_DONE: {
      SET: 'NAVBAR_TECHNICAL_DONE_SET'
    },
    PSYCHOMETRIC_DONE: {
      SET: 'NAVBAR_PSYCHOMETRIC_DONE_SET'
    }
  }
};

export default ACTION_ITEMS;



// WEBPACK FOOTER //
// ./src/components/navbar/actionItems.js